<template>
  <div style="width:100%;padding:10px;">
    <v-row style="display: flex;">
      <v-col cols="2" class="flex" style="width:100%;">
        <v-card>
          <v-card-text style="color:#000">
            <h2>Mark</h2>
            <p>{{ $route.query.mark }}</p>

            <h2>Model</h2>
            <p>{{ $route.query.model }}</p>

            <h2>Year</h2>
            <p>{{ $route.query.year }}</p>

            <p>Friens</p>
            <v-divider></v-divider>
            <p>Friens</p>
            <v-divider></v-divider>
            <p>Friens</p>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="10" class="flex">
        <v-card>
          <v-card-title class="black white--text">{{ $route.params.categ_name }}</v-card-title>
          <v-card-text>
            <v-row v-if="allParts.length > 0">
              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <v-row class="black--text">
                      <v-col cols="12" class="border-light my-3" v-for="p in allParts" :key="p.id">
                        <v-row>
                          <v-col cols="2">
                            <v-img :src="p.product.img_url" alt="Image" width="100%" v-if="p.product.img_url" />
                            <v-img src="../../assets/img/cam-icon.png" max-width="200" alt="Image" v-else/>
                          </v-col>
                          <v-col cols="8">
                            <div><strong>#{{ p.product.ref }}</strong> | {{ p.product.fournisseur }}</div>
                            <p style="color:0077fb;">{{p.product.name}}</p>
                            <v-row>
                              <v-col cols="3">
                                <strong>Note</strong> <br> {{ p.product.note }}
                              </v-col>
                              <v-col cols="9">
                                <strong>Applicable pour :</strong> <br> 
                                <table style="width: 100%">
                                  <tbody>
                                    <tr v-for="i in getGroupeBy(p.product.models)" v-bind:key="i.id">
                                      <td>{{ $route.query.mark }}</td>
                                      <td>{{ i.name }}</td>
                                      <td>{{ i.years.join(' - ') }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </v-col>
                              <v-col cols="6">
                                <strong>Quantité minimal requise</strong> <br> {{ p.product.min_quantity }}
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="2">
                            <div v-if="p.product.price && p.product.price!=='0.00'">
                              <h2 class="red--text text-center">
                                ${{p.product.price}}
                              </h2>
                              <div class="text-center">
                                <input type="number" min="1" class="form-control mx-auto" value="1">
                                <v-btn text small class="primary " @click="insertToCart(p)">
                                  <v-icon>mdi-cart-plus</v-icon>
                                  Ajouter au panier
                                </v-btn>
                              </div>
                            </div>
                            <h5 class="border-light" v-else>
                              <router-link :to="{name: 'Contact'}">Appelez-nous en magasin pour la disponibilité
                              </router-link>
                            </h5>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div v-else style="padding: 1% 30%">
              <img src="../../assets/img/no_result_still_2x.webp"/>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
        max-width="700"
        v-model="showModal"
        persistent
    >
        <template>
            <v-card>
                <div>
                    <v-btn
                        color="black"
                        icon
                        dark
                        @click="showModal = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <div class="delivery-header">
                    
                    <v-icon>mdi-map-marker-circle</v-icon>
                    <vue-google-autocomplete
                        ref="address"
                        id="map"
                        class="google-place-auto form-control"
                        :placeholder="$t('home.saisie_address')"
                        v-on:placechanged="getAddressData"
                        country="ca">
                    </vue-google-autocomplete>
                    <v-btn class="primary"
                      text style="margin-top: -6px"
                      @click="checkArea"
                    >
                      Entrer
                    </v-btn>
                </div>
                <p class="text-center red--text" v-if="!deliveryCheck && checked">
                  {{ $t('home.verifyAddressResult1') }}
                </p>
                <p class="text-center green--text" v-if="deliveryCheck">
                  {{ $t('home.verifyAddressResult2') }}
                </p>
                <div class="delivery-address-footer">
                    {{ $t('delivery_footer_slogan') }}
                </div>
            </v-card>
        </template>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex";
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: "CategoryParts",
  data: () => ({
    dialog: false,
    showModal: false,
    zipcode: '',
    checked : false,
    address: '',
    formatedAddress: '',
    temp: null,
    quantity: 1,
    headers: [
      { text: "Mark", value: "make", sortable: false },
      { text: "Name", value: "name", sortable: false },
      { text: "Year", value: "year", sortable: false }
    ]
  }),
  components: {
    VueGoogleAutocomplete
  },
  computed: {
    ...mapGetters(["allParts"]),
    ...mapGetters(["deliveryCheck"])
  },
  methods: {
    ...mapActions(["addProductToCart"]),

    insertToCart(p) {
      p["quantity"] = 1
      if(window.localStorage.getItem('deliveryAddress') == null) {
        this.temp = p
        this.showModal = true
      }else {
        this.addProductToCart(p)
      }
    },
    async checkArea() {
      this.checked = true
      console.log(this.address);
      let status = await this.$store.dispatch("checkArea", this.address)
      if(status) {
        this.addProductToCart(this.temp)
        this.temp = null
        window.localStorage.setItem('deliveryAddress', this.formatedAddress)
        this.showModal = false
      }
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
      this.formatedAddress = placeResultData.formatted_address;
    },
    getGroupeBy(xs) {
      var arr =  _(xs)
        .groupBy('car_model.name')
        .map(function(items, bdate) {
          return {
            name: bdate,
            years: _.map(items, 'car_model.year_from')
          };
        }).value();

      console.log(arr)
      return arr;
    }
  },
  created() {
    this.$store.dispatch("fetchByModelAndCategory", {
      model_d: this.$route.params.model_id,
      categ_id: this.$route.params.categ_id
    })

    this.dialog = true
    setTimeout(() => (this.dialog = false), 4000)
  }
}
</script>

<style scoped>
h2 p {
  color: #000!important;
}
.border-light {
  border: 1px solid #ccc;
  padding: 5px;
}
input[type=number] {
  width: 50%;
  padding: 5px 12px;
  margin: 8px auto;
  box-sizing: border-box;
  border: 1px solid gray;
  border-radius: 10%;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {

  opacity: 1;

}

.delivery-header {
  padding: 0px 20px;
  padding-bottom: 10px;
}

.google-place-auto {
  width: 70%;
  height: 40px;
  border: 1px solid rgb(24, 24, 218);
  border-radius: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
}

.delivery-address-footer {
  background-color: rgb(13, 13, 61);
  color: #ffffff;
  text-align: center;
  align-content: center;
  padding: 15px 0;
}

td {
  padding: 5px;
}

tr {
  border-bottom: 1px solid #ddd;
}
</style>
